import React from 'react';
import '../../css/PrivacyPolicy.css';

function PrivacyPolicy() {
    return (
        <div className="privacy-container">
            <h1>Privacy Policy</h1>

            <div className="privacy-content">
                <h2>Everything is for you</h2>
                <p>Your information will only be used to improve your shopping experience.</p>

                <h2>Our commitment</h2>
                <p>We promise to treat and secure your information as if it were our own.</p>

                <h2>To the point</h2>
                <p>We’ll tell it like it is and keep you up to date on everything you need to know.</p>

                <h2>There will be no small conversation</h2>
                <p>Let us know what you’d like to hear from us, and how you’d like to hear from us.</p>

                <h2>Only the most essentials</h2>
                <p>We will not hold your information indefinitely. We’ll erase it if we don’t require it.</p>

                <p>Keeping your information private when it comes to your style and those all-important personal touches, PrettyLoveColombo has your back. Our clients are extremely valuable to us, therefore protecting them by keeping their data and information secure at all times is a top responsibility...</p>

                <h2>HOW DO WE GET YOUR INFORMATION?</h2>
                <p>The majority of the information you, the client, give us comes from your interactions with us and our brand...</p>

                <h2>INFORMATION ON THE DEVICE</h2>
                <p>We collect device-specific information, such as the model, operating system, unique device identifiers, and mobile network information...</p>

                <h2>LOG INFORMATION</h2>
                <p>We automatically gather and store certain information in our server logs when you use our website or services...</p>

                <h2>STORAGE ON THE LOCAL DEVICE</h2>
                <p>We may use methods like browser web storage and application data caches to collect and store information locally...</p>

                <h2>COOKIES AND TECHNOLOGIES SIMILAR TO COOKIES</h2>
                <p>When our clients use our services, we work with a number of third-party service providers...</p>

                <h2>DELIVERY</h2>
                <p>We use your address and contact information to guarantee that we can deliver all of the must-have items you order...</p>

                <h2>MARKETING</h2>
                <p>If you choose to opt-in, we will use the information you enter to keep you informed about all of our newest news and offers...</p>

                <h2>PAYMENT</h2>
                <p>Our third-party payment processors utilize your card and address information to complete your purchase...</p>

                <h2>PREVENTION OF FRAUD</h2>
                <p>We use data to protect our customers and services against fraud and criminal activities...</p>

                <h2>SAVED ITEMS AND PURCHASE HISTORY</h2>
                <p>Your purchase history, wish list, and saved goods give us a pretty decent sense of what you like...</p>

                <h2>LOGGING IN THROUGH THIRD-PARTY APPLICATIONS</h2>
                <p>If you choose to log into your account with us using a third-party service, such as Facebook...</p>

                <h2>SERVICES TO CUSTOMERS</h2>
                <p>If you contact our customer service staff with a complaint or an issue...</p>

                <h2>EXPERIENCE OF THE USER</h2>
                <p>We employ cookie information and other technology to provide a tailored user experience...</p>

                <h2>ADVERTISING</h2>
                <p>We believe in getting ourselves and our brand out there through advertising...</p>

                <h2>INFORMATION EXCHANGE</h2>
                <p>We will never sell or share your personal information to untrustworthy third parties...</p>

                <h2>KEEPING RECORD OF YOUR INFORMATION</h2>
                <p>We maintain your personal information for as long as necessary to provide you services...</p>

                <h2>SAYING NO TO MARKETING MESSAGES YOU DON’T WANT</h2>
                <p>You can opt out of marketing messages by changing your account settings...</p>

                <h2>THESE ARE YOUR RIGHTS</h2>
                <p>You have the right to be informed, to access your data, to request deletion...</p>

                <h2>GET IN TOUCH WITH US</h2>
                <p>Contact us via our contact page for any privacy-related concerns...</p>

                <h2>COOKIES</h2>
                <ul>
                    <li><strong>Functionality Cookies</strong> – Allow users to browse and use core site features.</li>
                    <li><strong>Preference Cookies</strong> – Remember your language and country preferences.</li>
                    <li><strong>Analytics Cookies</strong> – Help us track interactions to improve services.</li>
                    <li><strong>Targeting & Advertising Cookies</strong> – Show you relevant ads and measure campaigns.</li>
                </ul>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
